export default __webpack_public_path__ + "static/media/circle-x-red.f857cb85.svg";